// ABOUTME: Search-table cell renderer for a node's assigned owner/dealership/client reference.
// ABOUTME: Shows "code - listName" for the resolved AssignedNodeRef, or nothing when unassigned.

import { Typography } from '@ds/coolshop';
import type { DataTableRow } from '@ds/data-table';
import type { Row } from '@tanstack/react-table';

type AssignedRefField = 'assignedOwner' | 'assignedDealership' | 'assignedClient';

type AssignedRef = {
    id: string;
    code: string;
    listName?: string | null;
};

export function GridCellAssignedRefRender({
    row,
    field,
}: {
    row: Row<DataTableRow>;
    field: AssignedRefField;
}) {
    const ref = (row.original as Record<string, unknown>)[field] as AssignedRef | null | undefined;

    if (!ref) {
        return null;
    }

    const label = ref.listName ? `${ref.code} - ${ref.listName}` : ref.code;

    return (
        <Typography variant="body2" overflow="hidden" textOverflow="ellipsis">
            {label}
        </Typography>
    );
}
